export default "<link href=\"https://fonts.googleapis.com/css?family=Material+Icons\" rel=\"stylesheet\">\n";